import * as React from 'react';
import { createComponent } from '@lit/react';
import { PopoverTooltipWC } from './popover-tooltip.wc';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../component-types-generics';

export type PopoverTooltipProps =
  GenerateComponentTypeWithChildren<PopoverTooltipWC>;

export type PopoverTooltipPropsWithRef =
  GeneratePropsWithRef<PopoverTooltipProps>;

export const PopoverTooltip = createComponent({
  tagName: PopoverTooltipWC.tagname,
  elementClass: PopoverTooltipWC,
  react: React,
}) as PopoverTooltipPropsWithRef;
